import React from 'react';
import classNames from 'classnames';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const MenuItem = ({
  href,
  target,
  shouldShowExternalOpeningMsg,
  className,
  children,
  onClick,
  ...anchorProps
})=> (
  <a
    href={href}
    target={target}
    className={className}
    onClick={onClick}
    {...anchorProps}
  >
    <span className="nav-link">
      {children}

      {
        shouldShowExternalOpeningMsg &&
          <span className="opens-in-external-view-wrapper">
            Opens in a new window
          </span>
      }
    </span>
  </a>
);

const MenuItemUi_ViewerVersion1 = ({
  href,
  target,
  className,
  selected,
  children,
  onClick
})=> (
  <MenuItem
    href={href}
    target={target}
    className={className}
    selected={selected}
    children={children}
    onClick={onClick}
  />
);

const MenuItemUi_ViewerVersion2 = ({
  href,
  target,
  className,
  selected,
  children,
  shouldShowExternalOpeningMsg,
  onClick
})=> {
  const ariaProps = {};

  if (selected) {
    ariaProps['aria-current'] = 'page';
  }

  return (
    <MenuItem
      href={href}
      shouldShowExternalOpeningMsg={shouldShowExternalOpeningMsg}
      target={target}
      className={classNames(className, {
        'zf-external-link': shouldShowExternalOpeningMsg
      })}
      selected={selected}
      children={children}
      onClick={onClick}
      {...ariaProps}
    />
  );
};

const MenuItemUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <MenuItemUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <MenuItemUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default MenuItemUi;
